import useWebSpeechPonyfill from './druid/useWebSpeechPonyfill';

export default function useResumeAudioContext(): () => Promise<void> {
  const [{ resumeAudioContext }] = useWebSpeechPonyfill();

  return () => resumeAudioContext && resumeAudioContext();
}
